import styled from "styled-components";


export const FromContainer = styled.div`  
  width: 420px;
  height: auto;  
  display: flex;
  flex-direction: column;  
  justify-content: center;
  box-sizing: border-box;  
  margin:0;
  @media (max-width: 768px) {
    width: 100%;    
    padding: 0 20px 0px;
  }
`;
